import {Menu} from '@mui/material'
import {styled} from '@mui/material/styles'
import {
  StyledFormControlLabel,
  StyledMenuItem,
  StyledRadioButton,
  StyledTypographyForMenu
} from './PopulationDensityDropDownStyle'
import PropTypes from 'prop-types'

const StyledMenu = styled(Menu)({
  '&.MuiPopover-root': {
    zIndex: 10
  }
})

const MenuWithRadioButton = ({anchorEl, open, label, options, onClick, onClose, selectedValue, menuStyleProps}) => {
  return (
    <StyledMenu
      id={`${label.replaceAll(' ', '-')}-menu`}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      transformOrigin={{horizontal: 'top', vertical: 'right'}}
      anchorOrigin={{horizontal: 'right', vertical: 'top'}}
      slotProps={{paper: menuStyleProps}}
      disableEnforceFocus
    >
      <StyledTypographyForMenu variant='labelLarge'>{label}</StyledTypographyForMenu>
      {options?.map((option) => (
        <StyledMenuItem
          key={option.label}
          disabled={option.disabled}
          onClick={(e) => {
            if (option.disabled) return
            e.preventDefault()
            e.stopPropagation()
            onClick(option.value)
            onClose()
          }}
        >
          <StyledFormControlLabel
            aria-label={`${option.label}`}
            value={option.value}
            label={option.label}
            control={<StyledRadioButton />}
            checked={selectedValue === option.value}
            disabled={option.disabled}
          />
        </StyledMenuItem>
      ))}
    </StyledMenu>
  )
}

export default MenuWithRadioButton

MenuWithRadioButton.propTypes = {
  anchorEl: PropTypes.object,
  open: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  selectedValue: PropTypes.string,
  menuStyleProps: PropTypes.object
}
